import React, { useEffect, useRef, useState } from "react";
import useToolGuideSync from "../../../../features/toolGuide/useToolGuideSync";
import { MANAGER_BUCKET_KEYS } from "../../../../features/toolGuide/toolGuideConfig";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const SelectResourceDropdown = ({
  selectedResource,
  setSelectedResource,
  employees,
  row,
  setShowListState,
  selectedTaskId,
}) => {
  const { syncToolGuideStep } = useToolGuideSync(
    MANAGER_BUCKET_KEYS.PROJECT_ONGOING,
    "L4_PM"
  );
  const [options, setOptions] = useState([]);
  const [matchedEmp, setmatchedEmp] = useState(null);
  const lastAppliedTaskKeyRef = useRef(null);
  useEffect(() => {
    if (!selectedTaskId?.taskownerid || !options?.length) return;
    // Apply task-based preselection only once per selected task.
    // This avoids overriding manual resource changes made by user.
    const selectedTaskKey = selectedTaskId?._id || `${selectedTaskId?.projectid || ""}-${selectedTaskId?.taskownerid || ""}`;
    if (lastAppliedTaskKeyRef.current === selectedTaskKey) return;

    const matchedEmp = options.find(
      (emp) => emp?.employee?._id === selectedTaskId.taskownerid
    );
    setmatchedEmp(matchedEmp);
    if (!matchedEmp) return;

    // ✅ if manager → set Self
    if (matchedEmp.label === "Self") {
      setSelectedResource(matchedEmp);
    } else {
      setSelectedResource(matchedEmp);
    }
    lastAppliedTaskKeyRef.current = selectedTaskKey;
    console.log("first useffect called");
  }, [options, selectedTaskId, setSelectedResource]);

  useEffect(() => {
    console.log("TaskInHand options", options);
    console.log("TaskInHand options selectedTaskId", selectedTaskId);
    console.log("TaskInHand options matchedEmp", matchedEmp);
    console.log("TaskInHand options selectedResource", selectedResource);
  }, [options, selectedResource, selectedTaskId, matchedEmp]);

  useEffect(() => {
    if (!row || !employees?.length) return;
    // 1. Find matchManager
    const matchEmail = row?.AssignedManagerEmail?.[0];
    const match = row.Assignedperson?.find((p) => p.email === matchEmail);
    const matchManager = employees.find((emp) => emp.EmpEmail === match?.email);
    // 2. Build dropdown options
    let newOptions = [];
    if (matchManager) {
      newOptions.push({
        label: "Self",
        value: matchManager.EmpEmail,
        data: matchManager, // keep full emp object
        employee: matchManager, // whole employees array
      });
    }
    // 3. Add others (not matched)
    row.Assignedperson?.forEach((p) => {
      if (p.email !== matchEmail) {
        newOptions.push({
          label: p.name,
          value: p.email,
          data: p,
          employee: employees.find((emp) => emp.EmpEmail === p.email) || {},
          // employee: employees.find((emp) => emp.EmpEmail === p.email || {}), // whole employees array
        });
      }
    });

    setOptions(newOptions);
    // Only set to "Self" when current selection is not valid for this row (e.g. first open or switched row).
    // Do not reset to Self when user has already chosen an operation person for this row.
    const currentOptionValues = newOptions.map((o) => o.value);
    if (matchManager) {
      setSelectedResource((prev) => {
        const selectionValid =
          prev?.value && currentOptionValues.includes(prev.value);
        if (selectionValid) return prev;
        return {
          label: "Self",
          value: matchManager.EmpEmail,
          data: matchManager,
          employee: matchManager,
        };
      });
    }
  }, [row, employees, setSelectedResource]);

  return (
    <div className="w-full flex flex-col gap-2">
      {options.map((opt, i) => (
        <button
          key={i}
          type="button"
          onClick={() => {
            syncToolGuideStep("view-details");
            setSelectedResource(opt);
            setShowListState("tasktable");
          }}
          className={` h-[1.5rem] border text-[12px] rounded-md shadow-md text-start px-1 overflow-hidden truncate
        ${
          selectedResource?.value === opt.value
            ? "bg-blue-500 text-white"
            : "bg-white border-gray-400"
        }
      `}
          title={opt.label} // shows full text on hover
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};

export default SelectResourceDropdown;
